import styled from "styled-components";
import { colors } from "../constants";

export default styled.div`
    height: 100%;
    width: 1px;
    background-color: ${colors.mediumTeal};
`;
